import classNames from 'classnames';
import Image from 'next/image';

import '../user-avatar.scss';

import noImage from '~/assets/no-image.webp';
import { useAppSelector } from '~/shared/store/hooks';
import { getAppUser } from '~/shared/store/slices/app/selectors';
import { getUserWithCourses } from '~/shared/store/slices/users/selectors';

const UserAvatarSkeleton = () => {
  return (
    <div className={classNames('user-avatar', 'user-avatar--guest')} title="Guest">
      <div className="user-avatar__image-wrapper">
        <Image
          alt="User"
          title="User"
          src={noImage.src}
          width={38}
          height={38}
          unoptimized
          sizes="38px"
          style={{ objectFit: 'cover' }}
        />
      </div>
    </div>
  );
};

export default UserAvatarSkeleton;
